import { RfiStatus } from 'app/modules/rfi/models';
import { ColorSchema } from 'vendor/material-minimal/palette';

export const RFI_STATUS_COLOR = {
  deleted: 'error',
  expired: 'error',
  pending: 'warning',
  submitted: 'success',
} as const satisfies Record<RfiStatus, ColorSchema>;

export const RFI_STATUS_LABEL: Record<RfiStatus, string> = {
  deleted: 'Deleted',
  expired: 'Expired',
  pending: 'Pending',
  submitted: 'Submitted',
};

export const RFI_LOGO_ALLOWED_TYPES = [
  'image/png',
  'image/jpeg',
  'image/gif',
  'image/webp',
] as const;

export const RFI_LOGO_MAX_BYTES = 2 * 1024 * 1024; // 2MB
